import type { IFontPresents } from '../models';

import { buildFontPreset } from './build-font-preset';

/**
 * @deprecated Устарело используйте fontViews
 */
export const fontPresets: IFontPresents = {
    // Text
    // @mixin paragraph_primary_large;
    primaryLarge: buildFontPreset(18, 24, 400),
    // @mixin paragraph_primary_normal;
    primaryNormal: buildFontPreset(16, 24, 400),
    // @mixin paragraph_primary_small;
    primarySmall: buildFontPreset(14, 20, 400),
    // @mixin paragraph_secondary_large;
    secondaryLarge: buildFontPreset(13, 16, 400),
    // @mixin paragraph_secondary_normal;
    secondaryNormal: buildFontPreset(12, 16, 400),
    //  @mixin paragraph_secondary_small;
    secondarySmall: buildFontPreset(11, 16, 400),
    component: buildFontPreset(16, 20, 400),
    'component-secondary': buildFontPreset(14, 18, 400),
    caps: buildFontPreset(12, 16, 500, 'uppercase', 125),
    // Title styrene
    // @mixin headline_xlarge;
    styreneXLarge: buildFontPreset(48, 64, 500),
    // @mixin headline_large;
    styreneLarge: buildFontPreset(40, 48, 500),
    // @mixin headline_normal;
    styreneNormal: buildFontPreset(32, 40, 500),
    // @mixin headline_small;
    styreneSmall: buildFontPreset(24, 32, 500),
    // @mixin headline_xsmall;
    styreneXSmall: buildFontPreset(20, 24, 500),
    // Title system
    // @mixin headline-system_xlarge;
    systemXLarge: buildFontPreset(48, 52, 700),
    // @mixin headline-system_large;
    systemLarge: buildFontPreset(40, 48, 700),
    // @mixin headline-system_normal;
    systemNormal: buildFontPreset(30, 36, 700),
    // @mixin headline-system_small;
    systemSmall: buildFontPreset(22, 26, 700),
    // @mixin headline-system_xsmall;
    systemXSmall: buildFontPreset(18, 22, 700),
};
